import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=91ef369e&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"
import style0 from "./sidemenu.vue?vue&type=style&index=0&id=91ef369e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ef369e",
  null
  
)

export default component.exports